<template>
    <v-app id="inspire">
        <app-sidebar :drawer.sync="drawer" />
        <app-header @toggle-drawer="drawer = !drawer" />

        <v-main>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import AppSidebar from "@/components/AppSidebar.vue";
import AppHeader from "@/components/AppHeader.vue";

export default {
    name: "MainLayout",
    components: {
        AppSidebar,
        AppHeader
    },
    data: () => ({
        drawer: true
    })
};
</script> 